import { TrendingUp, Shield, Users, Target } from "lucide-react";

const reasons = [
  {
    icon: TrendingUp,
    title: "Institutional-Grade Investment Structuring",
    description:
      "Learn how to structure investments that meet institutional standards and regulatory requirements for long-term capital deployment.",
  },
  {
    icon: Target,
    title: "Capital Market Alignment",
    description:
      "Understand the frameworks and processes that align professional practices with capital market infrastructure and institutional expectations.",
  },
  {
    icon: Shield,
    title: "Compliance and Governance Frameworks",
    description:
      "Master the compliance, governance, and operational standards required for institutional-grade capital management and investor servicing.",
  },
  {
    icon: Users,
    title: "Long-Term Capital Relationship Building",
    description:
      "Develop the skills to build sustainable, trust-based relationships with HNIs, UHNIs, family offices, and institutional investors.",
  },
];

export default function WhyThisMatters() {
  return (
    <section
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24
      bg-gradient-to-b from-[#F8FAFC] via-white to-[#F1F5F9] overflow-hidden"
    >
      {/* soft background accent */}
      <div className="absolute inset-x-0 top-40 h-[400px] bg-[#0E6F7E]/5 blur-3xl"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#07162E]">
              Why This Program Matters
            </h2>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-white/80 backdrop-blur-xl rounded-2xl p-8
              shadow-[0_20px_50px_rgba(2,8,23,0.08)]
              hover:shadow-[0_30px_70px_rgba(2,8,23,0.15)]
              transition-all duration-300 transform hover:-translate-y-2
              border-l-4 border-[#0E6F7E]"
            >
              <div className="flex items-start gap-4">
                {/* Icon */}
                <div
                  className="flex-shrink-0 w-14 h-14 rounded-xl
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  flex items-center justify-center
                  group-hover:scale-110 transition-transform duration-300"
                >
                  <reason.icon className="w-7 h-7 text-[#1DBF73]" />
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-xl font-bold text-[#07162E] mb-3">
                    {reason.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
